module.exports = __webpack_public_path__ + "static/staynow-macromenu-eb27908f879c5c1b82eb7cd4b6bd6bc5.jpg";